import {Nut_Settings_User} from 'nutshell-core/settings-constants';
import type {User} from 'nutshell-core/users/users-types';

import type {AccountPageFragment} from 'nutshell-graphql-types';

import {useActionBarFormTabSelection} from '../../../../core-entity/hooks/use-action-bar-form-tab-selection';
import {TAB_CALL} from '../../../../core-entity/redux/consts';
import {
    getTabOptions,
    useHandleCallClick,
    useOpenEmailModal,
    useOpenTextModal,
} from '../../../../core-entity/util/action-bar-helpers';
import {ActionBar as EntityActionBar} from '../../../../core-entity/workspace/action-bar';

type Props = {
    account: AccountPageFragment;
    user: User | null | undefined;
    getRef: (ref: HTMLDivElement | null) => void;
    hasScrolledPastCheckpoint: boolean;
};

export function AccountActionBar(props: Props) {
    const {actionBarTab, handleSelectFormTab} = useActionBarFormTabSelection(
        Nut_Settings_User.SETTING_ACCOUNT_PAGE_ACTION_BAR_TAB
    );

    const openEmailModal = useOpenEmailModal(props.account);
    const {openTextModal, featureGate} = useOpenTextModal(props.account, props.user);
    const {handleCallClick, popoverComponent} = useHandleCallClick(TAB_CALL, props.account.id, {
        noPhoneNumbersQuestion: 'No phone numbers associated with this company',
    });

    return (
        <>
            <EntityActionBar
                options={getTabOptions(openEmailModal, openTextModal, handleCallClick)}
                selectedTab={actionBarTab}
                onSelectTab={handleSelectFormTab}
                getRef={props.getRef}
                entityDisplayName={props.account.name}
                timelineEventFormProps={{
                    entityId: props.account.id,
                    entityName: 'Accounts',
                    canOpen: !props.hasScrolledPastCheckpoint,
                }}
            />
            {featureGate}
            {popoverComponent}
        </>
    );
}
